import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import React from 'react';
import Box from '../../UI';

export default function NDAContent({ id }) {
	return (
		<Body>
			<Typography variant="body1">The Parties:</Typography>
			<Typography variant="body1">
				(1) aXcess Marketplace Ltd ("aXcess", the " Company" or the "Disclosing Party")
			</Typography>
			<Typography variant="body1">(2) User AL213 of the aXcess platform, (the "Receiving Party")</Typography>
			<Typography variant="body1">
				Non-Disclosure Agreement related to the commercial real estate property with Asset FingerPrint ID number{' '}
				{id} (the "Asset").
			</Typography>
			<Typography variant="body1">Introduction:</Typography>
			<Typography variant="body1">
				The Receiving Party will be receiving information relating to the possible acquisition by the Receiving
				Party of the Asste (the "Transaction"). The Company may disclose to the receiving party Confidential
				Information (as defined below) in relation to the Asset. The Company wishes to ensure that the Receiving
				Party maintains the confidentiality of its Confidential Information. In consideration of the benefits to
				the Receiving Party of the disclosure of the Confidential Information, the receiving party has agreed to
				comply with the following terms in connection with the use and disclosure of such Confidential
				Information.
			</Typography>
			<Typography variant="body1">
				In relation to the Asset and the Transaction, the Receiving Party will receive certain proprietary and
				confidential information and undertake the following:
			</Typography>
			<Typography variant="body1">1. Maintaining confidentiality of information</Typography>
			<Typography variant="body1">
				The Receiving Party shall keep Confidential Information confidential and, in particular but without
				limitation, they shall:
			</Typography>
			<ul>
				<li>
					<Typography variant="body1">
						keep all documents and other material or media bearing or incorporating Confidential Information
						(in whatever form, whether tangible or intangible, and whether or not in human readable form)
						("Documents") separate from all other documents and materials not related to the Asset and the
						Transaction and at its usual place of business identified above;
					</Typography>
				</li>
				<li>
					<Typography variant="body1">
						exercise in relation to the Confidential Information and Documents all reasonable security
						measures and degree of care and which the Receiving Party;
					</Typography>
				</li>
				<li>
					<Typography variant="body1">
						warrants as providing adequate protection against any unauthorised disclosure, copying or use.
					</Typography>
				</li>
			</ul>
		</Body>
	);
}

const Body = styled(Box)`
	& p {
		margin-bottom: 1rem;
	}
`;
